export default "__VITE_ASSET__DVk0BeT4__"